import {datadogRum} from '@datadog/browser-rum';

datadogRum.init({
  applicationId: '7d8f8297-640f-417b-8a48-dd284cdba56f',
  clientToken: 'pubec51ecb3568b14e3e545ab2a6c614aaa',
  site: 'datadoghq.com',
  service: '041800001nkg---app-entry-ui',
  env: process.env.NODE_ENV === 'production' ? "prod" : "nonprod",
  sampleRate: 100,
  replaySampleRate: 100,
  trackInteractions: true,
  defaultPrivacyLevel: 'mask-user-input',
allowedTracingOrigins: [/https:\/\/.*\.myaccess\.allstatebenefits\.com/, /https:\/\/.*\.allstate\.com/],
});
datadogRum.addRumGlobalContext('space_name', 'env'); 
datadogRum.addRumGlobalContext('org_name', 'app-entry-ui');
datadogRum.addRumGlobalContext('barometerit', '041800001nkg');
datadogRum.startSessionReplayRecording();